module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan2-2-f250b2830ff995e5c2f2b4fc21fa8570.webp";